import React from 'react';
import SarasButton2 from '../../../../../library/input/buttons/button/SarasButton2';
import ProdIOOSumViewRow from './ProdIOOSumViewRow';

const QtyCell = ({ value1, value2, className = '', hideValue2 }) => {
    const displayValue1 = value1 === null || value1 === undefined || value1 === 0 ? '-' : value1;
    const displayValue2 = value2 === null || value2 === undefined || value2 === 0 ? '-' : value2;
    
    // const displayValue = displayValue1 && displayValue2
    //     ? `${displayValue1} / ${displayValue2}`
    //     : (displayValue1 || displayValue2);
    
    return (
        <li className={`uiColumnRight uiColumnQty ${className}`.trim()}>
            <div>{displayValue1}</div>
            {!hideValue2 && displayValue2 && <div>{displayValue2}</div>}
        </li>
    );
};

const ProdIOOSumGroupRow = ({ group, level, expanded, onToggle }) => {
    const canExpand = Array.isArray(group.childGroups) && group.childGroups.length > 0;
    const rowClass = level === 1 ? 'uiGroupLevel1' : 'uiGroupLevel2';

    return (
        <li>
            <ul className={`uiDPEditLine ${rowClass}`}>
                <li className="uiColumn uiColumnLeft uiColumn350">
                    <div className="uiFlexBox">
                        {canExpand ? (
                            <SarasButton2
                                icon={expanded ? 'collapse2' : 'expand2'}
                                onClick={() => onToggle(group.rowKey)}
                                containerClass="uiFlexBox"
                                className="uiDefaultIconButton"
                            />
                        ) : (
                            <span style={{ width: '24px', display: 'inline-block' }}></span>
                        )}
                        <span>{group.category}</span>
                    </div>
                </li>
                <li className="uiColumnLeft uiColumn130">
                </li>
                <li className="uiColumnLeft uiColumn50">
                    <div>{group.unit1}</div>
                    {group.unit2 ? <div>{group.unit2}</div> : null}
                </li>
                <QtyCell value1={group.qtyRequired1} value2={group.qtyRequired2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyAllocated1} value2={group.qtyAllocated2} className="uiColumnGroupSplit" hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyRequested1} value2={group.qtyRequested2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyReceived1} value2={group.qtyReceived2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyBalance1} value2={group.qtyBalance2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyReturnedToStock1} value2={group.qtyReturnedToStock2} className="uiColumnGroupSplit" hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyIssued1} value2={group.qtyIssued2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyReturnedByWorker1} value2={group.qtyReturnedByWorker2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyConsumed1} value2={group.qtyConsumed2} hideValue2={!group.unit2} />
                <QtyCell value1={group.qtyWasted1} value2={group.qtyWasted2} hideValue2={!group.unit2} className="uiColumnGroupSplit"/>
                <li className="uiColumnLeft uiColumn100">
                </li>
            </ul>
        </li>
    );
};

const ProdIOOSumGroupView = (props) => {
    const { groupsData, viewRows, formObject } = props;
    const [expandedRows, setExpandedRows] = React.useState({});

    const handleToggle = (rowKey) => {
        setExpandedRows((currentState) => ({
            ...currentState,
            [rowKey]: !currentState[rowKey]
        }));
    };

    return (
        <>
            {groupsData.map((level1Group) => (
                <React.Fragment key={level1Group.rowKey}>
                    <ProdIOOSumGroupRow
                        group={level1Group}
                        level={1}
                        expanded={!!expandedRows[level1Group.rowKey]}
                        onToggle={handleToggle}
                    />
                    {expandedRows[level1Group.rowKey] && (level1Group.childGroups || [])
                        .slice()
                        .sort((a, b) => (a.sortKey || '').localeCompare(b.sortKey || ''))
                        .map((level2Group) => (
                        <React.Fragment key={level2Group.rowKey}>
                            <ProdIOOSumGroupRow
                                group={level2Group}
                                level={2}
                                expanded={!!expandedRows[level2Group.rowKey]}
                                onToggle={handleToggle}
                            />
                            {expandedRows[level2Group.rowKey] && (level2Group.childGroups || []).map((masterRow, index) => {
                                const masterViewRow = viewRows ? viewRows[masterRow.masterRowKey] : null;
                                if (!masterViewRow) return null;

                                return (
                                    <React.Fragment key={masterRow.masterRowKey}>
                                        <li className="uiGroupLevel3">
                                            <ProdIOOSumViewRow
                                                formObject={formObject}
                                                rowKey={masterRow.masterRowKey}
                                                viewData={masterViewRow}
                                                groupedMode={1}
                                                indentPx={0}
                                                canExpand={(masterRow.childGroups || []).length > 0}
                                                expanded={!!expandedRows[masterRow.masterRowKey]}
                                                onToggle={handleToggle}
                                                index={index + 1}
                                            />
                                        </li>
                                        {expandedRows[masterRow.masterRowKey] && (masterRow.childGroups || []).map((batchRowKey) => {
                                            const batchViewRow = viewRows ? viewRows[batchRowKey] : null;
                                            if (!batchViewRow) return null;

                                            return (
                                                <li key={batchRowKey} className="uiGroupLevel4">
                                                    <ProdIOOSumViewRow
                                                        formObject={formObject}
                                                        rowKey={batchRowKey}
                                                        viewData={batchViewRow}
                                                        groupedMode={1}
                                                        indentPx={0}
                                                        showBatchId={1}
                                                        leadingIconKey="folder"
                                                    />
                                                </li>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            })}
                        </React.Fragment>
                    ))}
                </React.Fragment>
            ))}
        </>
    );
};

export default ProdIOOSumGroupView;
